<template>
    <div class="col-lg-4 col-md-6" v-if="model">
        <SmartLinkItemComponent :id="model?.system?.id" :component="!model.system.workflow">
            <div class="icon-item">
                <div class="img-container">
                    <NuxtImg :src="firstOrDefault(model.elements.icon.value)?.url" />
                </div>
                <div class="text-container">
                    <div class="icon-title">
                        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                            <p>{{ model.elements.title.value }}</p>
                        </SmartLinkStandaloneElement>
                    </div>
                    <div class="icon-description">
                        <SmartLinkStandaloneElement :codename="type.elements.description.codename">
                            <p>{{ model.elements.description.value }}</p>
                        </SmartLinkStandaloneElement>
                    </div>
                </div>
            </div>
        </SmartLinkItemComponent>
    </div>
</template>

<script lang="ts" setup>
import { contentTypes, type IconItemModel, } from '~~/app/models';
const type = contentTypes.icon_item;
const props = defineProps<{ model: IconItemModel }>();
</script>